export const ACTION_CARD_CLASS_NAME = 'kurama-action-card'
